module.exports = __webpack_public_path__ + "godot.523513.svg";